// extracted by mini-css-extract-plugin
export default {"table":"styles_table__JrvEf","negative":"styles_negative__WN--j","positive":"styles_positive__WZm5m"};